import apiClient from './client';

export async function getPortfolio() {
  // size=10000 loads all items; paginate properly when needed
  const res = await apiClient.get('/api/v1/portfolio', { params: { page: 0, size: 10000 } });
  return res.data.items ?? res.data;
}

export async function getPortfolioValue() {
  const res = await apiClient.get('/api/v1/portfolio/value');
  return res.data;
}

export async function refreshPortfolio() {
  const res = await apiClient.post('/api/v1/portfolio/refresh');
  return res.data; // { jobId }
}

export async function getRefreshStatus(jobId) {
  const res = await apiClient.get(`/api/v1/portfolio/refresh/${jobId}`);
  return res.data;
}